/*
 * sidebar (config)
 */
// import type { SidebarGroup } from "@psychology/react-components/server"
import type { AuthUser } from "@psychology/types"
import {
	Bot,
	Brain,
	FileText,
	HeartPlus,
	Info,
	LayoutDashboard,
	PocketKnife,
	Scale,
	ScrollText,
	Shield,
	SquareTerminal,
	Tags,
	User as UserIcon,
	Users,
} from "lucide-react"

export function getSidebarMenuList(
	user?: AuthUser | null,
	devMode?: boolean,
	psychologyFlags?: any,
): any[] {
	const dashboardGroup = {
		groupLabel: "",
		menus: [
			{
				href: "/dashboard",
				label: "Dashboard",
				icon: LayoutDashboard,
				submenus: [],
			},
		],
	}

	// Add intake link at top if user has no profile
	if (!psychologyFlags?.hasProfile) {
		dashboardGroup.menus.push({
			href: "/intake",
			label: "Profile Intake",
			icon: FileText,
			submenus: [],
		})
	}

	const menuList = [
		dashboardGroup,
		getMainMenuList(user),
		getBottomMenuList(user, devMode),
	].filter((group) => group)

	return menuList
}

/*
 * main
 */
function getMainMenuList(_user?: AuthUser | null) {
	const options: any = {
		groupLabel: "Services",
		menus: [
			{
				label: "Journal",
				icon: ScrollText,
				href: "/journal",
				submenus: [],
			},
			{
				label: "Chat",
				icon: Bot,
				href: "/chat",
				submenus: [],
			},
			{
				label: "Quizzes",
				icon: PocketKnife,
				href: "/quiz",
				submenus: [],
			},
			{
				label: "Emergency Plan",
				icon: HeartPlus,
				href: "/emergency/plan",
				submenus: [],
			},
			{
				label: "People",
				icon: Users,
				href: "/people",
				submenus: [],
			},
			{
				label: "Psychological Context",
				icon: Brain,
				href: "/psychological-context",
				submenus: [],
			},
			{
				label: "Traits",
				icon: Tags,
				href: "/traits",
				submenus: [],
			},
			{
				label: "Support Documents",
				icon: FileText,
				href: "/support",
				submenus: [],
			},
			{
				label: "User Details",
				icon: UserIcon,
				href: "/user-details",
				submenus: [],
			},
		],
	}

	return options
}

/*
 * bottom
 */
function getBottomMenuList(user?: AuthUser | null, devMode?: boolean) {
	const settings: any = { groupLabel: "Settings", menus: [] }

	if (user) {
		// Account
		settings.menus.push({
			href: "/auth/account",
			label: "Account",
			icon: UserIcon,
			submenus: [],
		})

		// Admin
		if ((user as any).user_metadata?.psychology?.isAdmin) {
			settings.menus.push({
				href: "/admin",
				label: "Admin",
				icon: Shield,
				submenus: [],
			})
		}
	}

	// Dev
	if (devMode) {
		settings.menus.push({
			href: "/dev",
			label: "Dev",
			icon: SquareTerminal,
			submenus: [],
		})
	}

	// Legal
	settings.menus.push({
		href: "/legal",
		label: "Legal",
		icon: Scale,
		submenus: [],
	})

	// About
	settings.menus.push({
		href: "/about",
		label: "About",
		icon: Info,
		submenus: [],
	})

	return settings
}
